//선박작업일정
import React, { useState } from "react";
import { Container } from "@mui/material";
import { CDate } from "../../../components/CDate";
import ManagerAppBar from "../common/ManagerAppBar";
import { addMonths, format, subMonths } from "date-fns";
import { mainColor } from "../../../assets/colors/color";
import { useRecoilValue } from "recoil";
import { getScheduleShipList } from "../../../recoil/GetData";
import ListBoxSchedule from "../../../components/ListBoxSchedule";
import { loginAuthenticationAdmin } from "../../../hooks/loginAuthentication";

function ManagerShipSchedule() {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const selectDay = format(selectedDate, "yyyy-M-dd");
  const year = format(currentMonth, "yyyy");
  const month = format(currentMonth, "MM");

  React.useEffect(() => {
    loginAuthenticationAdmin();
  }, []);

  const shipScheduleData = useRecoilValue(
    getScheduleShipList(`${year}-${month}-23`)
  );

  console.log(shipScheduleData);

  const prevMonth = () => {
    setCurrentMonth(subMonths(currentMonth, 1));
  };
  const nextMonth = () => {
    setCurrentMonth(addMonths(currentMonth, 1));
  };

  const onDateClick = (day) => {
    setSelectedDate(day);
  };

  return (
    <div>
      <ManagerAppBar />
      <Container
        maxWidth="sm"
        sx={{
          position: "relative",
          marginTop: "76px",
          marginBottom: "10px",
          gap: "10px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h1 style={{ fontSize: "20px" }}>선박 작업 일정</h1>

        <CDate
          edata={shipScheduleData && shipScheduleData}
          onDateClick={onDateClick}
          selectedDate={selectedDate}
          prevMonth={prevMonth}
          nextMonth={nextMonth}
          currentMonth={currentMonth}
        />
        <p
          style={{
            fontSize: 20,
            fontWeight: 700,
            color: `${mainColor}`,
            padding: "8px 0",
          }}
        >
          선택된 날짜 : {selectDay}{" "}
        </p>
        <ListBoxSchedule
          edata={shipScheduleData && shipScheduleData}
          selectedDate={selectedDate}
          NextPageType={"ManagerShipSchedule"}
        />
      </Container>
    </div>
  );
}

export default ManagerShipSchedule;
